module.exports = __webpack_public_path__ + "bg.a116ef1aa766b0531da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpg
// module id = 1095
// module chunks = 2